/** Detect pasted Eltern-Mail in chat — route to extraction, not companion chat. */

const HEADER_LABEL =
  /^(?:von|from|an|to|cc|bcc|betreff|subject|gesendet|sent|datum|date|reply-to)\s*:/i;

const HEADER_LABEL_FLAT =
  /\b(?:von|from|an|to|cc|bcc|betreff|subject|gesendet|sent|datum|date|reply-to)\s*:/gi;

const FORWARDED =
  /weitergeleitete nachricht|forwarded message|original message|urspr[uü]ngliche nachricht/i;

const SALUTATION =
  /\b(?:liebe eltern|hallo zusammen|guten tag|sehr geehrte)\b/i;

export const PASTED_MAIL_MIN_CHARS = 40;

/** @param {string} raw */
export function normalizePasteText(raw) {
  return String(raw || "").replace(/\r\n/g, "\n").trim();
}

/** @param {string} raw */
function headerCount(raw) {
  const onLines = raw
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => HEADER_LABEL.test(line)).length;
  const flat = raw.match(HEADER_LABEL_FLAT)?.length || 0;
  return Math.max(onLines, flat);
}

/**
 * True when pasted text is likely a full or partial Eltern-Mail.
 * @param {string} text
 */
export function looksLikePastedMail(text) {
  const raw = normalizePasteText(text);
  if (raw.length < PASTED_MAIL_MIN_CHARS) return false;
  if (FORWARDED.test(raw)) return true;

  const headers = headerCount(raw);
  if (headers >= 2) return true;

  const hasAddress = /[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+/.test(raw);
  if (headers >= 1 && hasAddress) return true;

  if (raw.length >= 160 && SALUTATION.test(raw.slice(0, 100))) return true;

  return false;
}

/**
 * Lift Betreff / Von from a pasted mail when present.
 * @param {string} text
 */
export function parsePastedMailHeaders(text) {
  const bodyText = normalizePasteText(text);
  let subject = "";
  let fromAddress = "";

  for (const line of bodyText.split("\n").slice(0, 40)) {
    const trimmed = line.trim();
    const subj = trimmed.match(/^(?:betreff|subject)\s*:\s*(.+)$/i);
    if (subj) subject = subj[1].trim();
    const von = trimmed.match(/^(?:von|from)\s*:\s*(.+)$/i);
    if (von) fromAddress = von[1].trim();
  }

  if (!subject) {
    const match = bodyText.match(
      /\b(?:betreff|subject)\s*:\s*([^\n]+?)(?=\s+(?:von|from|an|to|cc|bcc|gesendet|sent|datum|date)\s*:|$)/i,
    );
    if (match) subject = match[1].trim();
  }
  if (!fromAddress) {
    const match = bodyText.match(
      /\b(?:von|from)\s*:\s*([^\n]+?)(?=\s+(?:betreff|subject|an|to|cc|bcc|gesendet|sent|datum|date)\s*:|$)/i,
    );
    if (match) fromAddress = match[1].trim();
  }

  return {
    subject: subject.slice(0, 500),
    fromAddress: fromAddress.slice(0, 500),
    bodyText,
  };
}
